import {Player} from "@/store/player/types";

export abstract class ResourceContainer extends Phaser.GameObjects.Container {
    abstract setDefaultDepth(): void;
    abstract setTopDepth(): void;
    abstract setBalance(player: Player): void;
}
